var PLUS_REGEX = /\+/g; // Regex for replacing addition symbol with a space

function _decode(string) {
  return decodeURIComponent(string.replace(PLUS_REGEX, " "));
}

function _parseQueryString() {
  var match = null;
  var search = /([^&=]+)=?([^&]*)/g;
  var input =
    window.location.hash.indexOf("?") === 1
      ? window.location.hash
      : window.location.search;
  var queryString = input.substring(1);
  var urlParams = {};

  match = search.exec(queryString);

  while (match) {
    urlParams[_decode(match[1])] = _decode(match[2]);
    match = search.exec(queryString);
  }

  return urlParams;
}

export default _parseQueryString();
